import { Alert, type SxProps, type Theme } from '@mui/material';
import { useTranslation } from 'react-i18next';

/**
 * REV-1127: what every AI entry point shows instead of itself when the
 * organization has AI switched off, so the feature is explained rather than
 * silently missing. Static text, present when the page loads, so not a live
 * region.
 */
export default function AiOffNote({ sx }: { sx?: SxProps<Theme> }) {
  const { t } = useTranslation();
  return (
    <Alert severity="info" role="note" sx={sx}>
      {t(
        'ai.offNote',
        'AI features are turned off for this organization. An Owner or Admin can turn them back on under Integrations.'
      )}
    </Alert>
  );
}
